(function() {
  function focusSearch() {
    var mainSearch = document.querySelector('#Banner #search');
    if (mainSearch && !mainSearch.value) { mainSearch.select(); }
  }
  document.addEventListener('turbolinks:load', focusSearch);
})()